import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Meta, Title } from '@angular/platform-browser';

@Injectable()
export class MiscService {
  inFinnishPlease = true;
  languageChange: Subject<boolean> = new Subject<boolean>();

  constructor(
    private meta: Meta,
    private title: Title
  ) {
    if (window.location.hostname === 'energyefficiencyagreements2008-2016.fi') {
      this.toggleLanguage();
    }
  }

  toggleLanguage(): void {
    this.inFinnishPlease = !this.inFinnishPlease;
    this.languageChange.next(this.inFinnishPlease);

    // Update meta tags
    if (this.inFinnishPlease) {
      this.title.setTitle('Energiatehokkuussopimukset 2008–2016');
      this.meta.updateTag({ name: 'url', content: 'https://energiatehokkuussopimukset2008-2016.fi' });
      this.meta.updateTag({ name: 'title', content: 'Energiatehokkuussopimukset 2008–2016' });
      this.meta.updateTag({ name: 'description', content: 'Vuosien saatossa suomalaiset vapaaehtoiset energiatehokkuussopimukset ovat muovautuneet menestystarinaksi, jollaista ei löydy muualta maailmasta.' });
    } else {
      this.title.setTitle('Energy efficiency agreements 2008–2016');
      this.meta.updateTag({ name: 'url', content: 'https://energyefficiencyagreements2008-2016.fi/' });
      this.meta.updateTag({ name: 'title', content: 'Energy efficiency agreements 2008–2016' });
      this.meta.updateTag({ name: 'description', content: 'Over the years, Finnish voluntary Energy Efficiency Agreements have evolved into a unique success story that is not found elsewhere in the world.' });
    }
  }

  getLanguage(): boolean {
    return this.inFinnishPlease;
  }

}



// WEBPACK FOOTER //
// /Users/ilu/projektit/ets-tuloksia/src/app/services/misc.service.ts